import { useInfiniteQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { getCategoryProducts } from '../api'
import { keys } from '../queryKeys'

export type Product = {
  id: string
  name: string
  description: string
  ccn_path: string[]
  category_id: string
}

const useGetCategoryProductsQuery = ({
  catalogId,
  categoryId,
  region,
}: {
  catalogId: string | undefined
  categoryId: string | undefined
  region: string | undefined
}) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const getCategoryProductsQuery = useInfiniteQuery({
    queryKey: keys.categoryProducts({
      accountId,
      region,
      catalogId,
      categoryId,
    }),
    queryFn: ({ pageParam }) =>
      getCategoryProducts({
        accountId,
        region: region!,
        catalogId: catalogId!,
        categoryId: categoryId!,
        page: pageParam as number,
        limit: 10,
      }),
    initialPageParam: 1,
    enabled: !!accountId && !!catalogId && !!categoryId && !!region,
    getNextPageParam: (lastPage) =>
      lastPage.hasNextPage ? lastPage.currentPage + 1 : undefined,
    getPreviousPageParam: (firstPage) =>
      firstPage.hasPrevPage ? firstPage.currentPage - 1 : undefined,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    meta: {
      errorMessage: 'The category products could not be loaded',
    },
  })

  return getCategoryProductsQuery
}

export default useGetCategoryProductsQuery
